Function.prototype.bind=(function(){}).bind||function(b){if(typeof this!=="function"){throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");}function c(){}var a=[].slice,f=a.call(arguments,1),e=this,d=function(){return e.apply(this instanceof c?this:b||window,f.concat(a.call(arguments)));};c.prototype=this.prototype;d.prototype=new c();return d;};

var objectToString = Object.prototype.toString;
var slice = Array.prototype.slice;

function isArray(item) {
  return objectToString.call(item) === '[object Array]';
}

function isNodeList(item) {
  return objectToString.call(item) === '[object NodeList]';
}

// each([array], callback)
// breaks if callback returns 'break';
function each (items, cb) {

  for (let i = 0, l = items.length; i < l; ++i) {
    if (items.hasOwnProperty(i)) {
      if (cb(items[i]) === 'break') {
        break;
      }
    }
  }

  return items;
}
// map array
function map (items, cb) {
  let result = [];
  each(items, function (item, i) {
    result.push(cb(item, i));
  });
  return result;
}
// filter array
function filter (items, cb) {
  let result = [];
  each(items, function (item, i) {
    if (cb(item, i)) {
      result.push(item);
    }
  });
  return result;
}

// forEach(object, cb);
function forEach(obj, cb) {
  for (let i in obj) {
    if (obj.hasOwnProperty(i)) {
      cb(obj[i], i);
    }
  }
  return obj;
}


var div = document.createElement('div');

var supports = {
  classList: typeof div.classList === 'object' && typeof div.classList.add === 'function'
};

// hasClass(elem, className);
var hasClass = (function () {
  if (supports.classList) {
    return function (elem, className) {
      if (elem) {
        return elem.classList.contains(className);
      }
    };
  }
  return function (elem, className) {
    if (elem) {
      return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
    }
  };
}());

var singleAddClass = (function () {
  if (supports.classList) {
    return function singleAddClass(elem, className) {
      if (elem) {
        return elem.classList.add(className);
      }
    };
  }

  return function singleAddClass(elem, className) {
    if (elem) {
      if (hasClass(elem, className)) {
        return;
      }

      return elem.className += ' ' + className;
    }
  };
}());

var singleRemoveClass = (function () {
  if (supports.classList) {
    return function (elem, className) {
      return elem.classList.remove(className);
    };
  }
  return function (elem, className) {
    var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, ' ') + ' ';
    if (hasClass(elem, className)) {
      while (newClass.indexOf(' ' + className + ' ') >= 0) {
        newClass = newClass.replace(' ' + className + ' ', ' ');
      }

      elem.className = newClass.replace(/^\s+|\s+$/g, '');
    }
  };
}());

function checkSingleOrMultiple(elems, className, cb) {
  if (elems.length) {
    return each(elems, function (elem) {
      cb(elem, className);
    });
  }

  return cb(elems, className);
}

// addClass(elem, className);
// addClass(multipleElements, className);
function addClass(elems, className) {
  if (!className) {
    return;
  }

  return checkSingleOrMultiple(elems, className, singleAddClass);
}

// removeClass(elem, className);
// removeClas(elems, className);
function removeClass(elems, className) {
  if (!className) {
    return;
  }

  return checkSingleOrMultiple(elems, className, singleRemoveClass);
}

// Create a wrapper used to export classes
function create(Constructor) {
  return {
    create: function (...args) {
      return new Constructor(...args);
    }
  };
}


function _domEvent (item, eventName, callback, bubbling) {
  if (typeof item.addEventListener === 'function') {
    return item.addEventListener(eventName, callback, bubbling);
  } else if (typeof item.attachEvent === 'function') {
    return item.attachEvent(eventName, callback);
  }

  throw new Error('Browser does not support events');
}

function _domEventOff(item, eventName, callback) {
  if (typeof item.removeEventListener === 'function') {
    return item.removeEventListener(eventName, callback);
  } else if (typeof item.detachEvent === 'function') {
    return item.detachEvent(eventName, callback);
  }
}

function on(items, ...args) {
  if (isNodeList(items)) {
    items = slice.call(items);
  } else {
    items = [items];
  }

  each(items, function (item) {
    _domEvent(item, ...args);
  });
}

function off(items, ...args) {
  if (isNodeList(items)) {
      items = slice.call(items);
    } else {
      items = [items];
    }

  each(items, function (item) {
    _domEventOff(item, ...args);
  });
}

// prevents default on an event
// or the global event (IE)
function preventDefault (e) {
  if (e && e.preventDefault) {
    e.preventDefault();
  } else if (window.event && window.event.returnValue) {
    window.event.returnValue = false;
  }
}
// stops propagation
function stopPropagation(e) {
  if(!e) var e = window.event;

  //e.cancelBubble is supported by IE -
  // this will kill the bubbling process.
  e.cancelBubble = true;

  if ( typeof e.stopPropagation === 'function' ) e.stopPropagation();

  return false;
}


export default {
  addClass,
  removeClass,
  hasClass,
  each,
  forEach,
  map,
  filter,
  preventDefault,
  create,
  on,
  off,
  stopPropagation
};



// WEBPACK FOOTER //
// ./src/scripts/utils.js